import c from "../common";

export default {
  invisibleText: "This " + c.vendor.en.uppercase + " is hidden",
  visibleText: "This " + c.vendor.en.uppercase + " is visible to public",

  ChangeData: "Modify " + c.vendor.en.uppercase + " Detail",

  AppVisibility: "Visibility on mobile App",
  visible: "Visible",
  invisible: "Invisible",

  //Col of await approval
  AwaitApproval: "Please wait for approval",
  AwaitText: "You may modify the " + c.vendor.en.uppercase + " detail while waiting for approval.",

  //Need modification
  NeedModify: "Need Resubmit",
  //Badge of detail status
  CurrentData: "Current " + c.vendor.en.uppercase + " Detail",
  UnapproveData: "Unapproved " + c.vendor.en.uppercase + " Detail",

  //Pending Detail Tab
  NA: "Not Avaliable",

  text1: "View last change history",
  text2: "no information yet",
  text3: "You do not have the appropriate permissions",
  text4: "Error",
  text5: "Action",
  text6: "Show",
  text7: "Hide",
  text8: "Shop",
  text9: "Time",
};
